<template>
  <div class="main-content">
    <router-view></router-view>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
export default {
  name: 'MainContent',
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.main-content {
  position: absolute;
  left: 200px;
  right: 0px;
  bottom: 0px;
  top: 54px;
  // background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/MainContent/index.vue